module.exports = __webpack_public_path__ + "img/max-icons-bold.e1cc83e0.svg";